module.exports = __webpack_public_path__ + "media/images/lesson_7/sebastiao_sem_sucesso-9cd5ec10a5b832ff3d5213e71dc3c350.png";